"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianLumberYard = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Tags_1 = require("../../Tags");
const Resources_1 = require("../../../Resources");
const CardRenderer_1 = require("../../render/CardRenderer");
const Units_1 = require("../../../Units");
class MartianLumberYard extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.MARTIAN_LUMBER_YARD,
            tags: [Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ plants: 1, steel: 1 }),
            metadata: {
                cardNumber: 'Y14',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.steel(1).plants(1)).br;
                    b.steel(2).plants(3);
                }),
                description: 'Increase your steel and plant production 1 step. Gain 2 steel and 3 plants.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.STEEL);
        player.addProduction(Resources_1.Resources.PLANTS);
        player.addResource(Resources_1.Resources.STEEL, 2);
        player.addResource(Resources_1.Resources.PLANTS, 3);
        return undefined;
    }
}
exports.MartianLumberYard = MartianLumberYard;
//# sourceMappingURL=MartianLumberYard.js.map